module.exports = __webpack_public_path__ + "static/media/postman.b556a895.png";